import { BaseRequest } from './BaseRequest';

export class BulkInsertRequest extends BaseRequest {
    organizationRecords: string[];
}